import { Warning } from "@mui/icons-material";
import {
  Checkbox,
  Grid,
  ListItemText,
  Tooltip,
  Typography,
} from "@mui/material";
import { getExpiryDate, isValidAvailableSeats } from "data/functions";
import { ServiceSummary } from "data/interfaces";

interface ClaimSelectionItemProps {
  service: ServiceSummary;
  primaryText: string;
  secondaryText: string | null;
  selectedUsersCount: number;
  defaultChecked: boolean;
  handleCheckboxSelect: (
    checked: boolean,
  ) => void;
}

export function ClaimSelectionItem({
  service,
  primaryText,
  secondaryText,
  selectedUsersCount,
  defaultChecked,
  handleCheckboxSelect,
}: ClaimSelectionItemProps) {
  return (
    <Grid container spacing={2} alignItems="center">
      <Grid item xs>
        <Tooltip placement="left" title={getExpiryDate(service)}>
          <ListItemText primary={primaryText} secondary={secondaryText} />
        </Tooltip>
      </Grid>
      <Grid item xs="auto">
        {!isValidAvailableSeats(service, selectedUsersCount) ? (
          <>
            <Typography variant="caption" color="error" sx={{ pr: 1 }}>
              {`${service.seatsTotal - service.seatsUsed} seat(s) available`}
            </Typography>
            <Warning color="error" />
          </>
        ) : (
          <Typography variant="caption">
            {service.unlimitedSeats === true
              ? "Unlimited"
              : `${service.seatsTotal - service.seatsUsed} seat(s) available`}
          </Typography>
        )}
      </Grid>
      <Grid item xs={1}>
        <Checkbox
          disabled={!isValidAvailableSeats(service, selectedUsersCount)}
          defaultChecked={defaultChecked}
          edge="end"
          onChange={(e, checked) =>
            handleCheckboxSelect(checked)
          }
        />
      </Grid>
    </Grid>
  );
}
